import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

// Styles live in public/loader.css (linked from index.html) so the very same
// loader can also be shown before the app's JavaScript loads. Keep this markup
// in sync with the #fz-boot loader in public/index.html.
export const PageLoader = ({ hidden = false }) => (
  <div className={`fz-loader${hidden ? " fz-loader--hide" : ""}`} role="status" aria-live="polite" aria-hidden={hidden}>
    <div className="fz-stage">
      <div className="fz-orbit" aria-hidden="true">
        <span className="fz-spark" />
        <span className="fz-spark" />
        <span className="fz-spark" />
      </div>

      <div className="fz-float">
        <div className="fz-canvas">
          <div className="fz-face fz-front">
            <span className="fz-art">ف</span>
            <span className="fz-sheen" />
          </div>
          <div className="fz-face fz-back" />
          <div className="fz-face fz-side fz-right" />
          <div className="fz-face fz-side fz-left" />
          <div className="fz-face fz-side fz-top" />
          <div className="fz-face fz-side fz-bottom" />
        </div>
      </div>

      <span className="fz-shadow" />
    </div>

    <div className="fz-brand">
      <span className="fz-name">فَذَكِّرْ</span>
      <span className="fz-tagline">نُجهّز لوحتك بكل حب…</span>
      <span className="fz-bar" />
    </div>
  </div>
);

const SHOW_MS = 1600; // how long the loader stays up on a page change

// Shows the loader briefly whenever the page (route) changes. Kept in its own
// component so its state never re-renders App (which would rebuild the layout).
const RouteLoader = () => {
  const { pathname } = useLocation();
  const firstRender = useRef(true);
  const [mounted, setMounted] = useState(false);
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    // The first page is covered by the boot loader in index.html
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    setMounted(true);
    // Next frame: fade in from the hidden state
    const show = requestAnimationFrame(() => setHidden(false));
    const hide = setTimeout(() => setHidden(true), SHOW_MS);
    const unmount = setTimeout(() => setMounted(false), SHOW_MS + 400);

    return () => {
      cancelAnimationFrame(show);
      clearTimeout(hide);
      clearTimeout(unmount);
    };
  }, [pathname]);

  return mounted ? <PageLoader hidden={hidden} /> : null;
};

export default RouteLoader;
